export const newsItems = [
  {
    id: 1,
    date: '6 – 11 avril 2026',
    dateEn: 'April 6–11, 2026',
    title: 'ITF J30 Douala 2026 — Session 1',
    titleEn: 'ITF J30 Douala 2026 — Session 1',
    excerpt: 'Premier tournoi international junior jamais organisé par le Tennis Club de Douala. 30 points ITF à gagner. Ouvert aux joueurs de 13 à 18 ans.',
    excerptEn: 'First-ever international junior tournament hosted by Tennis Club de Douala. 30 ITF ranking points at stake. Open to players aged 13–18.',
    image: 'https://readdy.ai/api/search-image?query=International%20junior%20tennis%20tournament%20ceremony%20with%20young%20athletes%20holding%20trophies%20on%20podium%2C%20golden%20evening%20light%2C%20green%20tennis%20court%20background%2C%20flags%20of%20participating%20nations%2C%20celebration%20atmosphere%2C%20prestigious%20sports%20event%2C%20professional%20photography&width=600&height=400&seq=news-itf-01&orientation=landscape',
    category: 'Tournois',
    categoryEn: 'Tournaments',
    featured: true,
  },
  {
    id: 2,
    date: '13 – 18 avril 2026',
    dateEn: 'April 13–18, 2026',
    title: 'ITF J30 Douala 2026 — Session 2',
    titleEn: 'ITF J30 Douala 2026 — Session 2',
    excerpt: 'Deuxième session du tournoi ITF J30. Encore plus de joueurs internationaux attendus. Dir. de tournoi : Eric Tanga.',
    excerptEn: 'Second session of the ITF J30 tournament. Even more international players expected. Tournament Director: Eric Tanga.',
    image: 'https://readdy.ai/api/search-image?query=Intense%20tennis%20match%20between%20two%20teenage%20players%20on%20a%20clay%20court%2C%20dynamic%20action%20shot%20mid-rally%2C%20umpire%20chair%20and%20ball%20kids%20in%20background%2C%20green%20court%20surface%2C%20bright%20sunlight%2C%20sports%20competition%20photography&width=600&height=400&seq=news-itf-02&orientation=landscape',
    category: 'Tournois',
    categoryEn: 'Tournaments',
    featured: true,
  },
  {
    id: 3,
    date: '8 juin – 31 août 2026',
    dateEn: 'June 8 – August 31, 2026',
    title: 'Kid Summer Camp 2026',
    titleEn: 'Kid Summer Camp 2026',
    excerpt: 'Programme estival pour les 5–16 ans. Deux sessions au choix. Tennis, IA, Yoga, sports collectifs. 35 000 FCFA/mois.',
    excerptEn: 'Summer program for ages 5–16. Two sessions available. Tennis, AI, Yoga, team sports. 35,000 XAF/month.',
    image: 'https://readdy.ai/api/search-image?query=Happy%20children%20aged%205-16%20participating%20in%20summer%20tennis%20camp%20activities%2C%20group%20photo%20with%20tennis%20rackets%2C%20colorful%20sportswear%2C%20green%20outdoor%20court%2C%20sunny%20day%20with%20blue%20sky%2C%20energetic%20joyful%20atmosphere%2C%20fun%20sports%20photography&width=600&height=400&seq=news-camp-01&orientation=landscape',
    category: 'Formation',
    categoryEn: 'Training',
    featured: false,
  },
  {
    id: 4,
    date: 'Mars 2026',
    dateEn: 'March 2026',
    title: 'Formation Coaching International',
    titleEn: 'International Coach Training',
    excerpt: '4 jours de formation intensive avec Coach Boutoto Rapontchombo, diplômé international. Participants venus de plusieurs villes du Cameroun.',
    excerptEn: '4-day intensive training with Coach Boutoto Rapontchombo, internationally certified. Participants from multiple Cameroonian cities.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20tennis%20coaching%20seminar%20with%20group%20of%20coaches%20sitting%20in%20classroom%20setting%20near%20tennis%20court%2C%20presentation%20screen%20showing%20tactics%2C%20clipboards%20and%20notebooks%2C%20educational%20atmosphere%2C%20bright%20natural%20light&width=600&height=400&seq=news-coaching-01&orientation=landscape',
    category: 'Formation',
    categoryEn: 'Training',
    featured: false,
  },
  {
    id: 5,
    date: 'Dates à confirmer',
    dateEn: 'Dates TBC',
    title: 'Tournoi Lumière des Femmes',
    titleEn: "Women's Light Tournament",
    excerpt: 'Tournoi interclub dédié aux joueuses féminines. Compétition, partage et célébration du tennis féminin au Cameroun.',
    excerptEn: "Interclub tournament dedicated to female players. Competition, sharing, and celebration of women's tennis in Cameroon.",
    image: 'https://readdy.ai/api/search-image?query=Women%20tennis%20players%20competing%20in%20a%20friendly%20tournament%20on%20outdoor%20court%2C%20female%20athletes%20shaking%20hands%20at%20net%2C%20sportsmanship%20moment%2C%20green%20court%20and%20bright%20sunlight%2C%20empowering%20atmosphere%2C%20beautiful%20daytime%20photography&width=600&height=400&seq=news-women-01&orientation=landscape',
    category: 'Événements',
    categoryEn: 'Events',
    featured: false,
  },
  {
    id: 6,
    date: 'Prochainement',
    dateEn: 'Coming Soon',
    title: 'Extension Padel — Début des travaux',
    titleEn: 'Padel Expansion — Groundbreaking',
    excerpt: 'Les travaux de construction des 2 premiers terrains de Padel du Cameroun débuteront prochainement. Une révolution sportive à Douala.',
    excerptEn: "Construction of Cameroon's first 2 Padel courts will begin soon. A sporting revolution in Douala.",
    image: 'https://readdy.ai/api/search-image?query=Modern%20padel%20court%20with%20glass%20walls%20and%20artificial%20turf%20under%20bright%20sunlight%2C%20players%20in%20action%20through%20glass%2C%20surrounded%20by%20green%20landscape%2C%20luxury%20sports%20facility%2C%20blue%20sky%20with%20white%20clouds%2C%20architectural%20sports%20photography&width=600&height=400&seq=news-padel-01&orientation=landscape',
    category: 'Développement',
    categoryEn: 'Development',
    featured: false,
  },
];